
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';
    import InformationBlock from '../../components/Contact/InformationBlock.vue';

    export default {
        head: function () {
            return {
                title: this.$store.state.contactsPageData.meta_title || this.$nuxt.$options.head.title,
                meta: [
                    { hid: 'description', name: 'description', content: this.$store.state.contactsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },

                    { hid: 'og:title', property: 'og:title', content: this.$store.state.contactsPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'og:description', property: 'og:description', content: this.$store.state.contactsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'og:image', property: 'og:image', content: this.$store.state.contactsPageData.background_image },

                    { hid: 'twitter:title', name: 'twitter:title', content: this.$store.state.contactsPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'twitter:description', name: 'twitter:description', content: this.$store.state.contactsPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'twitter:image', name: 'twitter:image', content: this.$store.state.contactsPageData.background_image }
                ],
            };
        },
        components: {
            HeadingSection,
            InformationBlock,
        },
        computed: {
            contactsPageData() {
                return this.$store.state.contactsPageData;
            },
        },
        async asyncData(context) {
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages/17`)
                .then((response) => {
                    context.store.dispatch("setContactsPageData", response.data.acf);
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
